import type { CloudFileService } from '@/constants/cloudFiles';

/*
 * Google Drive and OneDrive marks on their own, for pages that show them
 * without the whole connector icon set (@/components/Chat/connectors/icons
 * renders these too).
 */

export const GoogleDriveLogo = ({ className }: { className?: string }) => (
  <svg viewBox='0 0 16 16' className={className} aria-hidden='true'>
    <path
      d='M1.84624 12.6235L2.48571 13.728C2.61858 13.9605 2.80959 14.1432 3.03382 14.2761L5.31765 10.3231H0.75C0.75 10.5805 0.816439 10.8379 0.949316 11.0705L1.84624 12.6235Z'
      fill='#0066DA'
    />
    <path
      d='M8.00011 5.67238L5.71628 1.71931C5.49205 1.85219 5.30104 2.0349 5.16816 2.26743L0.949316 9.57562C0.818882 9.80314 0.750174 10.0608 0.75 10.3231H5.31765L8.00011 5.67238Z'
      fill='#00AC47'
    />
    <path
      d='M12.9663 14.2761C13.1905 14.1432 13.3815 13.9605 13.5144 13.728L13.7802 13.2712L15.0508 11.0705C15.1837 10.8379 15.2501 10.5805 15.2501 10.3231H10.6821L11.6541 12.2331L12.9663 14.2761Z'
      fill='#EA4335'
    />
    <path
      d='M8.00013 5.67238L10.284 1.71931C10.0597 1.58643 9.80228 1.52 9.53652 1.52H6.46374C6.19799 1.52 5.94054 1.59474 5.71631 1.71931L8.00013 5.67238Z'
      fill='#00832D'
    />
    <path
      d='M10.6824 10.3231H5.31752L3.03369 14.2761C3.25792 14.409 3.51537 14.4754 3.78112 14.4754H12.2188C12.4846 14.4754 12.742 14.4007 12.9663 14.2761L10.6824 10.3231Z'
      fill='#2684FC'
    />
    <path
      d='M12.9414 5.92153L10.8319 2.26743C10.6991 2.0349 10.5081 1.85219 10.2838 1.71931L8 5.67238L10.6825 10.3231H15.2418C15.2418 10.0656 15.1754 9.80816 15.0425 9.57562L12.9414 5.92153Z'
      fill='#FFBA00'
    />
  </svg>
);

// The Fluent-era OneDrive cloud (CC0 svg-logos set).
export const OneDriveLogo = ({ className }: { className?: string }) => (
  <svg viewBox='0 0 256 165' className={className} aria-hidden='true'>
    <path
      fill='#0364B8'
      d='m154.66 110.682l52.842-50.534c-10.976-42.8-54.57-68.597-97.37-57.62a80 80 0 0 0-46.952 33.51c.817-.02 91.48 74.644 91.48 74.644'
    />
    <path
      fill='#0078D4'
      d='m97.618 45.552l-.002.009a63.7 63.7 0 0 0-33.619-9.543c-.274 0-.544.017-.818.02C27.852 36.476-.432 65.47.005 100.798a63.97 63.97 0 0 0 11.493 35.798l79.165-9.915l60.694-48.94z'
    />
    <path
      fill='#1490DF'
      d='M207.502 60.148a53 53 0 0 0-3.51-.131a51.8 51.8 0 0 0-20.61 4.254l-.002-.005l-32.022 13.475l35.302 43.607l63.11 15.341c13.62-25.283 4.164-56.82-21.12-70.44a52 52 0 0 0-21.148-6.1'
    />
    <path
      fill='#28A8EA'
      d='M11.498 136.596a63.91 63.91 0 0 0 52.5 27.417h139.994a51.99 51.99 0 0 0 45.778-27.323l-98.413-58.95z'
    />
  </svg>
);

export const CloudServiceLogo = ({
  service,
  className,
}: {
  service: CloudFileService;
  className?: string;
}) =>
  service === 'google-drive' ? (
    <GoogleDriveLogo className={className} />
  ) : (
    <OneDriveLogo className={className} />
  );
